
const getUsuarioLogado = (state) => {
  return state.logado
}

export {
  getUsuarioLogado
}



// WEBPACK FOOTER //
// ./src/store/usuario/getters.js